if (!customElements.get('product-card-variants')) {
  customElements.define('product-card-variants', class ProductCardVariants extends HTMLElement {
    constructor() {
      super();
      this.variantsData = null;
      this.variantInput = null;
      this.submitButton = null;
    }
    
    connectedCallback() {
      const formId = this.dataset.formId;
      const form = document.getElementById(formId);
      
      if (!form) return;
      
      this.variantInput = form.querySelector('.product-variant-id-complementary');
      this.submitButton = form.querySelector('[type="submit"]');
      
      const variantsDataEl = this.querySelector('[data-variants]');
      if (variantsDataEl) {
        this.variantsData = JSON.parse(variantsDataEl.textContent);
      }
      
      this.addEventListener('change', this.handleChange.bind(this));
      
      // Initialize with current selection
      this.updateVariant();
    }
    
    handleChange(event) {
      if (event.target.tagName === 'SELECT') {
        this.updateOptionsAvailability();
        this.updateVariant();
      }
    }
    
    updateOptionsAvailability() {
      const selects = this.querySelectorAll('select');
      
      // Get current selections (excluding placeholders)
      const currentSelections = Array.from(selects).map(select => {
        const selectedOption = select.options[select.selectedIndex];
        // If the first option (placeholder) is selected, or no value, return empty string
        if (select.selectedIndex === 0 || !selectedOption.value) {
          return '';
        }
        return selectedOption.value;
      });
      
      // Update each select's options
      selects.forEach((select, selectIndex) => {
        const options = Array.from(select.options);
        
        options.forEach((option, optionIndex) => {
          // Skip the first option (placeholder) and any option without a value
          if (optionIndex === 0 || !option.value) {
            return;
          }
          
          // Check if this option value would result in an available variant
          const isAvailable = this.variantsData.some(variant => {
            // This option must match the variant
            const optionKey = `option${selectIndex + 1}`;
            if (variant[optionKey] !== option.value) {
              return false;
            }
            
            // Check against other selected options (not placeholders)
            for (let i = 0; i < currentSelections.length; i++) {
              // Skip the current select index
              if (i === selectIndex) continue;
              
              const selectedValue = currentSelections[i];
              // If another select has a real value (not placeholder), check it
              if (selectedValue) {
                const otherOptionKey = `option${i + 1}`;
                if (variant[otherOptionKey] !== selectedValue) {
                  return false;
                }
              }
            }
            
            // Variant matches all criteria, check if it's available
            return variant.available;
          });
          
          // Update option state
          if (isAvailable) {
            option.disabled = false;
          } else {
            option.disabled = true;
          }
        });
      });
    }
    
    updateVariant() {
      if (!this.variantsData || !this.variantInput) return;
      
      const selects = this.querySelectorAll('select');
      const selectedOptions = Array.from(selects).map(select => select.value);
      
      const matchingVariant = this.variantsData.find(variant => {
        return selectedOptions.every((option, index) => {
          const optionKey = `option${index + 1}`;
          return variant[optionKey] === option;
        });
      });
      
      const variantIdInputComplementary = this.parentNode.querySelector('input.product-variant-id-complementary');
      const submitButton = this.parentNode.querySelector('button');
      const submitButtonText = submitButton.querySelector('.product-card__atc-text');
      
      if (matchingVariant) {
        
        // Update the hidden input value
        if (matchingVariant.id) {
          variantIdInputComplementary.value = matchingVariant.id;
        } else {
          variantIdInputComplementary.value = '';
        }
        
        // Update button and input states based on availability
        if (submitButton) {
          if (matchingVariant.available) {
            submitButton.removeAttribute('disabled');
            submitButtonText.innerHTML = 'Add To Cart';
            variantIdInputComplementary.removeAttribute('disabled');
          } else {
            submitButton.setAttribute('disabled', 'disabled');
            submitButtonText.innerHTML = 'Choose Options';
            variantIdInputComplementary.setAttribute('disabled', 'disabled');
          }
        }
      } else {
        // No matching variant found - disable the button
        if (submitButton) {
          submitButton.setAttribute('disabled', 'disabled');
          submitButtonText.innerHTML = 'Choose Options';
        }
        if (variantIdInputComplementary) {
          variantIdInputComplementary.value = '';
          variantIdInputComplementary.setAttribute('disabled', 'disabled');
        }
      }
    }
  });
}

